/// <amd-module name="Search/Code/Flux/Sources/CodeRefreshInfoSource" />

import * as Rest_Client from "Search/WebApi/RestClient/Search";
import * as Contracts from "Search/WebApi/Contracts/Search";
import { IVssPageContext } from "VSS/Platform/Context";
import { getGitClient } from "VC/Common/RestClient/Git";
import { getTfvcClient } from "VC/Common/RestClient/Tfvc";
import * as VC from "VC/Common/Contracts/Git";

export class CodeRefreshInfoSource {
    private _codeSearchRestClient: Rest_Client.ISearchRestClient;
   
    constructor(
        private readonly pageContext: IVssPageContext) {
        this._codeSearchRestClient = this.pageContext.getRestClient<Rest_Client.ISearchRestClient>("ISearchRestClient");
    }

    public getGitRefreshInfo(
        project: string,
        repo: string)
        : Promise<Contracts.RepositoryStatusResponse> {      
        return this._codeSearchRestClient
            .getRepositoryStatus(project, repo);
    }

    public getTFVCRefreshInfo(
        project: string
       )
        : Promise<Contracts.TfvcRepositoryStatusResponse> {
        return this._codeSearchRestClient
            .getTfvcRepositoryStatus(project);
    }

    public getGitCommit(
        commitId: string,
        repository: string,
        project: string
    ): Promise<VC.GitCommit> {
        return getGitClient(this.pageContext).getCommit(commitId, repository, project);
    }

    public getTfvcCommit(
        commitId: number,
        project: string
    ): Promise<VC.TfvcChangeset> {
        return getTfvcClient(this.pageContext).getChangeset(commitId, project);
    }

    public getBranchData(
        branch : string,
        repositoryId: string,
        project: string,
        commitDate: string
    ): Promise<VC.GitCommitRef[]> {
        const searchCriteria = {
            itemVersion: { version: branch },
            fromDate: commitDate
        } as VC.GitQueryCommitsCriteria;
        return getGitClient(this.pageContext).getCommitsBatch(searchCriteria, repositoryId, project);
    }

    public getTFVCChangeData(
        fromChangeDate: string,
        project: string
    ): Promise<VC.TfvcChangesetRef[]> {
        const searchCriteria = {
            fromDate: fromChangeDate
        } as VC.TfvcChangesetSearchCriteria;
        return getTfvcClient(this.pageContext).getChangesets(project, undefined, undefined, undefined, undefined, searchCriteria);
    }

    public getCustomRefreshInfo(
        project: string,
        repository: string)
        : Promise<Contracts.CustomRepositoryStatusResponse> {
        return this._codeSearchRestClient
            .getCustomRepositoryStatus(project, repository);
    }

    public getCustomChangeData(
        project: string,
        repository: string,
        branch: string)
        : Promise<Contracts.CustomRepositoryBranchStatusResponse> {
        return this._codeSearchRestClient
            .getCustomRepositoryBranchStatus(project, repository, branch);
    }
}